import { render, staticRenderFns } from "./LanguageDirectionField.vue?vue&type=template&id=1a4ce676&"
import script from "./LanguageDirectionField.vue?vue&type=script&lang=ts&"
export * from "./LanguageDirectionField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports